import { withStyles } from '@material-ui/core';
import styles from './recommendationStyles';
import {
  getEstimatedMilesRemaining,
  getEstimatedTravelTime,
  getTrailerCapacityText
} from './utils';

const RecommendationDetailsTable = ({ classes, data }) => {
  
  const details = [
    {
      label: 'Proj. Trailer Space',
      value: getTrailerCapacityText(data)
    },
    { label: 'Arrival', value: data.arrivalTime },
    { label: 'Total Miles', value: getEstimatedMilesRemaining(data) },
    { label: 'Total Time', value: getEstimatedTravelTime(data) },
    {
      label: 'Missed Stops',
      value: data.numServiceViolations,
      customClass: data.numServiceViolations > 0 ? classes.missedStops : ''
    }
  ];

  const renderDetail = ({ label, value, customClass = '' }) => {
    return (
      <div className={classes.recommendationCardDetail}>
        <div className={classes.recommendationCardDetailLabel}>{label}</div>
        <div className={`${customClass} ${classes.recommendationCardDetailValue}`}>{value}</div>
      </div>
    );
  };

  return (
    <div className={classes.recommendationCardDetailsContainer}>{details.map(renderDetail)}</div>
  );
};

export default withStyles(styles)(RecommendationDetailsTable);
